export default "__VITE_ASSET__DhMpdJ0T__"